import Headroom from 'headroom.js';
import toArray from './../../scripts/to-array';

toArray(document.querySelectorAll('[data-component="header-sticky"]')).forEach((component) => {
  const componentTop = component.getBoundingClientRect().top + window.pageYOffset;
  const componentHeight = component.getBoundingClientRect().height;

  const offsetOnTop = componentTop + componentHeight;
  const offsetNotOnTop = componentTop;

  const headroom = new Headroom(component, {
    offset: offsetOnTop,
    onTop: () => {
      headroom.offset = offsetOnTop;
      component.classList.remove('headroom--animation');
    },
    onNotTop: () => {
      headroom.offset = offsetNotOnTop;
      requestAnimationFrame(() => component.classList.add('headroom--animation'));
    },
  });

  headroom.init();

  component.querySelector('[data-header-sticky-nav-button]').addEventListener('click', () => {
    document.body.classList.toggle('is-header-sticky-open');
    component.classList.toggle('is-open');
  });
});
